export default __webpack_public_path__ + "static/media/left-arrow-ylw.c4aa0978.svg";